import Vue from 'vue'
import Vuex from 'vuex'
/* eslint-disable */
import VuexPersistence from 'vuex-persist'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

export default new Vuex.Store({
  state: {
    loading: false,
    formLoading: false,
    error: null,
    user: {},
    roles: [],
    permissions: [],
    users: [],
    settings: [],
    activeCustomers: [],
    inactiveCustomers: [],
    customerDetails: {},
    userDetails: {},
    loans: [],
    activeloans: [],
    pendingloans: [],
    approvedloans: [],
    declinedloans: [],
    disbursedloans: [],
    loanDetails: {},
    loanTypes: [],
    loanReasons: [],
    userRedflag: []
  },
  mutations,
  actions,
  getters,
  strict: debug,
  plugins: [vuexLocal.plugin]
});